module.exports = __webpack_public_path__ + "static/assets/2fe969399d52e076d779f489ca815728.gif";